// extracted by mini-css-extract-plugin
export default {"root":"IconLogout_root__LzxQe"};